var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoogleDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L22.5962 6.36364L18.0769 0Z",
    fill: "#4285F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8701 10.1113L28.9231 20.2204V10.9091L18.8701 10.1113Z",
    fill: "url(#paint0_linear_356_2023)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23077 29.0909H21.6923V27.2727H7.23077V29.0909ZM7.23077 32.7273H18.0769V30.9091H7.23077V32.7273ZM7.23077 20V21.8182H21.6923V20H7.23077ZM7.23077 25.4545H21.6923V23.6364H7.23077V25.4545Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0V8.18182C18.0769 9.68864 19.2903 10.9091 20.7884 10.9091H28.9231L18.0769 0Z",
    fill: "#A1C2FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71154 0C1.22019 0 0 1.22727 0 2.72727V2.95455C0 1.45455 1.22019 0.227273 2.71154 0.227273H18.0769V0H2.71154Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2115 39.7727H2.71154C1.22019 39.7727 0 38.5454 0 37.0454V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V37.0454C28.9231 38.5454 27.7029 39.7727 26.2115 39.7727Z",
    fill: "#1A237E",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_356_2023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 40
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_356_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7884 10.9092C19.2903 10.9092 18.0769 9.6887 18.0769 8.18188V8.40916C18.0769 9.91598 19.2903 11.1364 20.7884 11.1364H28.9231V10.9092H20.7884Z",
    fill: "#1A237E",
    fillOpacity: 0.1
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0769 0H2.71154C1.22019 0 0 1.22727 0 2.72727V37.2727C0 38.7727 1.22019 40 2.71154 40H26.2115C27.7029 40 28.9231 38.7727 28.9231 37.2727V10.9091L18.0769 0Z",
    fill: "url(#paint1_radial_356_2023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_356_2023",
    x1: 23.8971,
    y1: 10.9793,
    x2: 23.8971,
    y2: 20.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_356_2023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.916297 0.790599) scale(46.638 46.638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleDocs);
export default __webpack_public_path__ + "static/media/icon-google-docs.1bafcfd110d627ed378e9fdcb6342b6d.svg";
export { ForwardRef as ReactComponent };